import { render, staticRenderFns } from "./InstallPrompt.vue?vue&type=template&id=1f6a3233&scoped=true&"
import script from "./InstallPrompt.vue?vue&type=script&lang=js&"
export * from "./InstallPrompt.vue?vue&type=script&lang=js&"
import style0 from "./InstallPrompt.vue?vue&type=style&index=0&id=1f6a3233&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a3233",
  null
  
)

export default component.exports